'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _connectConfigure = require('../connectors/connectConfigure');

var _connectConfigure2 = _interopRequireDefault(_connectConfigure);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Configure is a widget that lets you provide raw search parameters
 * to the Algolia API.
 *
 * Any of the props added to this widget will be forwarded to Algolia. For more information
 * on the different parameters that can be set, have a look at the
 * [reference](https://www.algolia.com/doc/api-client/javascript/search#search-parameters).
 *
 * This widget can be used either with react-dom and react-native. It will not render anything
 * on screen, only configure some parameters.
 *
 * Read more in the [Search parameters](guide/Search_parameters.html) guide.
 * @name Configure
 * @kind widget
 * @example
 * import React from 'react';
 * import { InstantSearch, Configure, Hits } from 'react-instantsearch-dom';
 *
 * const App = () => (
 *   <InstantSearch
 *     appId="latency"
 *     apiKey="6be0576ff61c053d5f9a3225e2a90f76"
 *     indexName="ikea"
 *   >
 *     <Configure hitsPerPage={5} />
 *     <Hits />
 *   </InstantSearch>
 * );
 */

exports.default = (0, _connectConfigure2.default)(function () {
  return null;
});


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch-core/dist/cjs/widgets/Configure.js
// module id = 1074
// module chunks = 142807904292071